import axios from 'axios';

/** Shared response normalizers for apiClient services (B4.3). */
export const unwrapList = (d) => (Array.isArray(d) ? d : d?.$values ?? d?.items ?? d?.Items ?? []);

/** Best-effort API / interceptor error text for toasts. */
export function extractApiErrorMessage(err, fallback = 'Request failed') {
  if (!err) return fallback;
  if (axios.isCancel(err)) {
    const msg = String(err.message || '');
    if (/subscription/i.test(msg)) return 'Your subscription is inactive.';
    if (/session expired/i.test(msg)) return 'Your session expired. Please sign in again.';
    return msg || fallback;
  }
  const data = err.response?.data;
  if (data) {
    const envelope =
      data.error?.message
      ?? data.Error?.Message
      ?? data.message
      ?? data.Message;
    if (envelope) return envelope;
    if (data.title && data.errors) {
      const parts = Object.values(data.errors).flat().filter(Boolean);
      if (parts.length) return parts.join('; ');
      return data.title;
    }
  }
  return err.displayMessage ?? err.message ?? fallback;
}

export const unwrap = (d) => unwrapList(d);

export const unwrapPaged = (d) => d?.items ?? d?.Items ?? unwrapList(d);

export const toPaged = (d, pageNumber, pageSize) => ({
  items: unwrapPaged(d),
  total: d?.total ?? d?.Total ?? unwrapPaged(d).length,
  page: d?.page ?? d?.Page ?? pageNumber,
  pageSize: d?.pageSize ?? d?.PageSize ?? pageSize,
});

/** Standard API envelope: { success, data, meta?, error? } */
export const unwrapEnvelope = (response) => {
  const body = response?.data ?? response;
  if (body?.success === false) {
    const msg = body?.error?.message ?? body?.Error?.Message ?? 'API request failed';
    throw new Error(msg);
  }
  return {
    data: body?.data ?? body?.Data ?? body,
    meta: body?.meta ?? body?.Meta ?? null,
  };
};

export const unwrapEnvelopeData = (response) => unwrapEnvelope(response).data;

export const unwrapEnvelopePaged = (response, fallbackPage = 1, fallbackSize = 50) => {
  const { data, meta } = unwrapEnvelope(response);
  const items = unwrapList(data);
  return {
    items,
    total: meta?.totalCount ?? meta?.TotalCount ?? data?.total ?? data?.Total ?? items.length,
    page: meta?.page ?? meta?.Page ?? data?.page ?? data?.Page ?? fallbackPage,
    pageSize: meta?.pageSize ?? meta?.PageSize ?? data?.pageSize ?? data?.PageSize ?? fallbackSize,
  };
};
